import { useEffect, useRef } from 'react'

import { DayButtonProps } from 'react-day-picker'

import Tooltip from '../Tooltip/Tooltip'

import { useDateTooltip } from './DateTooltipContext'

const DayButtonWithTooltip = ({ day, modifiers, ...buttonProps }: DayButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null)
  const getDateTooltip = useDateTooltip()

  useEffect(() => {
    if (modifiers.focused) {
      ref.current?.focus()
    }
  }, [modifiers.focused])

  const tooltipContent = getDateTooltip?.(day.date) ?? undefined
  const button = <button ref={ref} {...buttonProps} />

  if (tooltipContent) {
    return <Tooltip content={tooltipContent}>{button}</Tooltip>
  }
  return button
}

export default DayButtonWithTooltip
